export const vidrisContrastColor: string = '#FDE724';
export const magmaContrastColor: string = '#FDE724';
export const ceruleanContrastColor: string = '#A7E3D7';
export const pastelContrastColor: string = '#8BD3C7';
export const hanaContrastColor: string = '#E4A061';
